import type { CommentData } from '@app/api/collaboration';

import type { KeyCommentList, ProjectCommentList, ThreadCommentList, TranslationCommentList } from './types';
import { CommentList } from './types';

const getGravatarUrl = (gravatarHash: string, size: number) =>
    `//www.gravatar.com/avatar/${gravatarHash}?d=retro&s=${size}`;

const sortComments = (comments: CommentData[]) =>
    comments
        // Create copy of the array before calling sort (sort mutates existing array)
        .slice()
        .sort((commentA, commentB) => {
            if (commentA.read && !commentB.read) {
                return 1;
            }
            if (!commentA.read && commentB.read) {
                return -1;
            }

            return commentB.createdAt - commentA.createdAt;
        });

export { getGravatarUrl, sortComments };

export const createProjectCommentList = (props: Omit<ProjectCommentList, 'type'>): ProjectCommentList => ({
    type: CommentList.Project,
    ...props,
});

export const createKeyCommentList = (props: Omit<KeyCommentList, 'type'>): KeyCommentList => ({
    type: CommentList.Key,
    ...props,
});

export const createTranslationCommentList = (props: Omit<TranslationCommentList, 'type'>): TranslationCommentList => ({
    type: CommentList.Translation,
    ...props,
});

export const createThreadCommentList = (props: Omit<ThreadCommentList, 'type'>): ThreadCommentList => ({
    type: CommentList.Thread,
    ...props,
});

export const getTranslationAttachPointComponents = (attachPointName: string): [keyName: string, language: string] => {
    const delimiterIndex = attachPointName.lastIndexOf(':');

    return [attachPointName.substring(0, delimiterIndex), attachPointName.substring(delimiterIndex + 1)];
};
